import interpolate, {
  type TranslateFn,
  type TranslationOptions,
} from "@app/_utils/interpolate";
import { use } from "react";
import type { Dictionary } from "types/common";
import { TranslationContext } from "../_context/translationContext";

export type { TranslateFn, TranslationOptions };

export default function useTranslate(): TranslateFn {
  const translations = use(TranslationContext);

  if (!translations) {
    const translate: TranslateFn = (key) => key;
    return translate;
  }

  const dictionary = translations;

  function translate(key: string, options: TranslationOptions<true>): string | undefined;
  function translate(key: string, options?: TranslationOptions<false>): string;
  function translate(
    key: string,
    options?: TranslationOptions<boolean>,
  ): string | undefined {
    if (options?.strict) return dictionary[key];
    const translation = dictionary[key] ?? `!${key}`;
    return interpolate(translation, options as TranslationOptions<false>);
  }

  return translate;
}

export function useTranslationMap(): Dictionary {
  return (use(TranslationContext) ?? {}) as Dictionary;
}
